<template>
  <div class="history-item">
    <span class="date">{{data.dateCreated | dateFormat('M/DD/YYYY')}}</span>
    <div class="name-status">
      <span class="name">{{referralName}}</span>
      <badge v-if="data.status" :class="statusClass" :value="data.status | statusName(statuses)" />
    </div>
    <span class="phone">{{data.referralContactPhone}}</span>
    <span class="description"
      >{{data.note}}</span
    >
    <button type="button" class="icon-button rounded action" @click="openMenu()"><i class="glyphicons glyphicons-option-vertical"></i></button>
  </div>
</template>

<script>
import Badge from '@components/badge.vue'
import {ReferralProgramHistoryStatus} from '@/shared/enums/referral.enum.js'
import { mapGetters } from 'vuex'
export default {
  name: 'referral-history-item',
  components: {
    Badge
  },
  props: ['data'],
  filters: {
    statusName: function (statusId, statuses) {
      let status = statuses.find(x => x.id === statusId)
      if (!status) return
      return status.text
    }
  },
  computed: {
    ...mapGetters({
      statuses: 'recommendFriend/statuses'
    }),
    statusClass () {
      let className = ''
      switch (this.data.status) {
        case ReferralProgramHistoryStatus.Pending:
          className = 'blue'
          break
        case ReferralProgramHistoryStatus.Sent:
          className = 'orange'
          break
        case ReferralProgramHistoryStatus.Purchased:
          className = 'green'
          break
      }
      return className
    },
    referralName () {
      return `${this.data.firstName} ${this.data.lastName}`
    }
  },
  methods: {
    openMenu () {
      this.$emit('openMenu')
    }
  },
  data: function () {
    return {}
  }
}
</script>

<style scoped>
.history-item {
  display: grid;
  grid-template-columns: auto min-content;
  gap: 0 24px;
  align-content: flex-start;
}
.name,
.date,
.description {
  font-size: 16px;
}

.date,
.description {
  font-weight: 400;
}

.name,
.description {
  color: rgba(33, 33, 33, 1);
}

.date {
  color: rgba(136, 136, 136, 1);
}

.name, .phone {
  font-weight: 700;
}

.name-status{
  grid-area: 2 / 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.badge {
  align-self: flex-start;
  justify-self: flex-start;
  grid-area: 2 / 2;
  min-height: 24px !important;
}

.description{
  grid-area: 4 / 1;
}

.action {
    grid-area: span 3 / -2;
}

.phone{
  grid-area: 3 / 1;
}

.badge.orange {
  background-color: rgba(255, 143, 0, 1);
  color: rgba(0, 0, 0, 1);
}
.badge.green {
  background-color: rgba(25, 190, 61, 1);
  color: rgba(0, 0, 0, 1);
}
.badge.blue {
  background-color: rgba(25, 190, 61, 1);
  color: rgba(0, 0, 0, 1);
}
</style>



// WEBPACK FOOTER //
// referral-history-item.vue?a5873fe6